import React, { useState, useEffect } from 'react';
        import { motion } from 'framer-motion';
        import { supabase } from '../../config/supabase';
        import SafeIcon from '../../common/SafeIcon';
        import * as FiIcons from 'react-icons/fi';

        const { FiCheck, FiX, FiExternalLink } = FiIcons;

        const PendingJobsTab = () => {
          const [pendingJobs, setPendingJobs] = useState([]);
          const [loading, setLoading] = useState(true);

          useEffect(() => {
            fetchPendingJobs();
          }, []);

          const fetchPendingJobs = async () => {
            try {
              const { data, error } = await supabase
                .from('jobs')
                .select('*, profiles(name, instagram_handle)')
                .eq('status', 'pending')
                .order('created_at', { ascending: false });

              if (error) throw error;
              setPendingJobs(data || []);
            } catch (error) {
              console.error('Error fetching pending jobs:', error);
            } finally {
              setLoading(false);
            }
          };

          const handleApprove = async (id) => {
            try {
              const { error } = await supabase.from('jobs').update({ status: 'approved' }).eq('id', id);
              if (error) throw error;
              fetchPendingJobs();
            } catch (error) {
              console.error('Error approving job:', error);
            }
          };

          const handleReject = async (id) => {
            if (window.confirm('Are you sure you want to reject this job posting?')) {
              try {
                const { error } = await supabase.from('jobs').delete().eq('id', id);
                if (error) throw error;
                fetchPendingJobs();
              } catch (error) {
                console.error('Error rejecting job:', error);
              }
            }
          };

          if (loading) {
            return (
              <div className="flex items-center justify-center py-12">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
              </div>
            );
          }

          return (
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-gray-900">Pending Jobs ({pendingJobs.length})</h2>
              </div>
              {pendingJobs.length === 0 ? (
                <div className="text-center py-12">
                  <h3 className="text-lg font-medium text-gray-900 mb-2">No pending jobs</h3>
                  <p className="text-gray-600">All job postings have been reviewed.</p>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {pendingJobs.map((job) => (
                    <motion.div
                      key={job.id}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow"
                    >
                      <div className="flex items-center justify-between mb-4">
                        <div>
                          <h3 className="text-lg font-semibold text-gray-900">{job.title}</h3>
                          <p className="text-gray-600 text-sm">by {job.profiles?.name || 'N/A'}</p>
                        </div>
                        {job.apply_url && (
                             <a href={job.apply_url} target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:text-purple-700">
                                <SafeIcon icon={FiExternalLink} />
                            </a>
                        )}
                      </div>
                      <p className="text-gray-700 text-sm mb-4 line-clamp-3">{job.description}</p>
                      
                      <div className="flex space-x-2">
                        <button onClick={() => handleApprove(job.id)} className="flex-1 flex items-center justify-center space-x-2 bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors">
                          <SafeIcon icon={FiCheck} />
                          <span>Approve</span>
                        </button>
                        <button onClick={() => handleReject(job.id)} className="flex-1 flex items-center justify-center space-x-2 bg-red-600 text-white py-2 rounded-lg hover:bg-red-700 transition-colors">
                          <SafeIcon icon={FiX} />
                          <span>Reject</span>
                        </button>
                      </div>
                    </motion.div>
                  ))}
                </div>
              )}
            </div>
          );
        };

        export default PendingJobsTab;